import "react-datepicker/dist/react-datepicker.css";
import * as actions_profiles from 'actions/profiles-actions';
import * as actions_users from 'actions/users-actions';
import * as actions_work_orders from 'actions/work-orders-actions';
import * as toolbox from 'components/common/toolbox';
import Map, { FullscreenControl, GeolocateControl, Marker, NavigationControl, Layer, Source } from 'react-map-gl';
import React, { useEffect, useState } from 'react';
import TechnicianMarker from './components/technician-marker';
import TooltipOverlay from "components/common/tooltip-overlay";
import moment from "moment";
import { Avatar, Ibox, Input } from 'enspire-manager-framework';
import { Badge } from "react-bootstrap";
import { numPanels } from 'components/common/toolbox';
import { useHistory } from 'react-router-dom';
import { useLocation, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useSelector, useDispatch } from 'react-redux';
import { PERMISSIONS } from "components/constants";

export default function ServiceMap(props) {

    /* Hooks ----------------------------------------------------------------------------------------------------------------------------------------------------------------*/

    const dispatch = useDispatch();
    const params = useParams();
    const location = useLocation();
    const history = useHistory();
    const mapRef = React.useRef();

    const company = useSelector((store) => store.company);
    const employees = useSelector((store) => store.employees.employees);
    const profiles = useSelector((store) => store.profiles);
    const user = useSelector(store => store.users.user);
    const user_permissions = useSelector(store => store.users.user_permissions);
    const workOrders = useSelector((store) => store.workOrders);
    const work_orders_unassigned = useSelector((store) => store.workOrders.work_orders_unassigned);

    const employee_id = params.profile_id;
    const selectedDate = (employee_id == '0') ? moment() : moment(params.date, 'YYYY-MM-DD');
    const isViewAll = user_permissions[PERMISSIONS.SERVICE_MAP_VIEW_ALL.key];

    /* States ----------------------------------------------------------------------------------------------------------------------------------------------------------------*/

    const [showMap, setShowMap] = useState(true);
    const [cursor, setCursor] = useState('auto');
    const [markers, setMarkers] = useState([]);
    const [startMarker, setStartMarker] = useState(null);
    const [selectedMarker, setSelectedMarker] = useState(null);
    const [technicianMarkers, setTechnicianMarkers] = useState([]);
    const [technicianBounds, setTechnicianBounds] = useState([]);
    const [isTechBound, setIsTechBound] = useState(false);
    const [stillMarkers, setStillMarkers] = useState(null);
    const [gpsCoordinates, setGpsCoordinates] = useState(null);
    const [viewport, setViewport] = useState({
        latitude: company?.company?.geopoint?.latitude ?? 39.833333,
        longitude: company?.company?.geopoint?.longitude ?? -98.583333,
        zoom: 11,
    });
    const [rendering, setRendering] = useState(false);

    /* Effects ----------------------------------------------------------------------------------------------------------------------------------------------------------------*/

    // Give map window time for full-width
    // useEffect(() => {
    //     setTimeout(() => {
    //         setShowMap(true);
    //     }, 500);
    // }, []);

    useEffect(() => {
        dispatch(actions_profiles.subProfileLocations(params.handle));
        return () => {
            let unsubscribe = profiles.profile_locations_unsubscribe;
            if (typeof unsubscribe === "function") unsubscribe();
        };
    }, [params.handle]);
    
    useEffect(() => {
        // setRendering(true);
        // dispatch(actions_work_orders.subIncompleteWorkOrders(params.handle, (employee_id == 'all') ? moment() : selectedDate, null, (employee_id == 'all') ? null : employee_id));

        // return () => {
        //     let unsubscribe = workOrders.work_orders_incomplete_unsubscribe;
        //     if (typeof unsubscribe === 'function') unsubscribe();
        // };
    }, [employee_id, employees, params.date]);


    // Once incomeplete work orders are fetched, set markers
    useEffect(() => {
        var newMarkers = incompleteWorkOrders?.filter((wo) => wo.id != params.tab_id && wo.geopoint)?.map((workOrder) => {
            // if (!workOrder.geopoint.latitude || !workOrder.geopoint.longitude) return null;
            return (
                <div key={workOrder.id} onMouseEnter={() => setCursor('pointer')} onMouseLeave={() => setCursor('auto')}>
                    <Marker
                        // color={'purple'}
                        draggable={false}
                        key={workOrder.id}
                        longitude={workOrder?.geopoint?.longitude}
                        latitude={workOrder?.geopoint?.latitude}
                        anchor="bottom"
                        onClick={() => handleClick(workOrder)}
                    />
                </div>
            );
        });

        // Set Unassigned Work Order Markers
        if (work_orders_unassigned?.length) {
            work_orders_unassigned?.filter((wo) => wo.id != params.tab_id && wo.geopoint)?.forEach((workOrder) => {
                if (workOrder?.geopoint) {
                    newMarkers.push(<div key={workOrder.id} onMouseEnter={() => setCursor('pointer')} onMouseLeave={() => setCursor('auto')}>
                        <Marker
                            color={'red'}
                            draggable={false}
                            key={workOrder.id}
                            longitude={workOrder?.geopoint?.longitude}
                            latitude={workOrder?.geopoint?.latitude}
                            anchor="bottom"
                            onClick={() => handleClick(workOrder)}
                        />
                    </div>);
                }
            });
        }
        setMarkers(newMarkers);

        // Set Selected Marker
        const selectedWorkOrder = incompleteWorkOrders?.find((wo) => wo.id == params.tab_id) || work_orders_unassigned?.find((wo) => wo.id == params.tab_id);
        if (selectedWorkOrder?.geopoint) {
            setSelectedMarker(
                <div onMouseEnter={() => setCursor('pointer')} onMouseLeave={() => setCursor('auto')}>
                    <Marker
                        color={'gold'}
                        // scale={1.25} //In case you wanted to change scale as well
                        draggable={false}
                        key={selectedWorkOrder.id}
                        longitude={selectedWorkOrder?.geopoint?.longitude}
                        latitude={selectedWorkOrder?.geopoint?.latitude}
                        anchor="bottom"
                        onClick={() => handleClick(selectedWorkOrder)}
                    />
                </div>
            );
        } else setSelectedMarker(null);

    }, [workOrders.work_orders_incomplete.data, params.tab_id, params.date, work_orders_unassigned]);

    // Once markers are set, fit bounds
    useEffect(() => {
        if (mapRef.current) {
            if (!isTechBound && technicianMarkers.length) {
                mapRef.current.fitBounds(technicianBounds, { padding: 100, duration: 2500, maxZoom: 15 });
                setIsTechBound(true);
            }
        }
    }, [technicianMarkers, mapRef.current]);

    // Set Technician Markers
    useEffect(() => {

        let markerLongitudes = [];
        let markerLatitudes = [];
        let techMarkers = [];

        Object.entries(profiles.profile_locations).forEach(([key, location]) => {

            const employee = employees?.find((emp) => emp.id === key);
           
            if (employee && location?.lat && location?.lng && (isViewAll || employee.id == user.profileId)) {
                markerLongitudes.push(location.lng);
                markerLatitudes.push(location.lat);
                techMarkers.push(
                    <TechnicianMarker
                        key={employee.id}
                        employee={employee}
                        location={location}
                        setCursor={setCursor}
                    />
                );
            }
        });
        setTechnicianMarkers(techMarkers);

        const minLng = Math.min(...markerLongitudes);
        const maxLng = Math.max(...markerLongitudes);
        const minLat = Math.min(...markerLatitudes);
        const maxLat = Math.max(...markerLatitudes);
        setTechnicianBounds([[minLng, minLat],[maxLng, maxLat]]);

    }, [params.handle, profiles.profile_locations, employees, isViewAll]);


    /* Handlers ----------------------------------------------------------------------------------------------------------------------------------------------------------------*/

    const handleClick = (workOrder) => {
        let newLocation = toolbox.modifyPath(location.pathname, 6, workOrder.id);

        history.replace({ pathname: newLocation });
    };

    /* Constants ----------------------------------------------------------------------------------------------------------------------------------------------------------------*/

    const incompleteWorkOrders = workOrders.work_orders_incomplete.data?.filter((wo) => wo.geopoint && wo.endDate.toDate().getDate() == selectedDate.toDate().getDate());

    // If no company location, center on continental US
    const COMPANY_LOCATION = {
        latitude: company?.company?.geopoint?.latitude ?? 39.833333,
        longitude: company?.company?.geopoint?.longitude ?? -98.583333,
    };

    /* Render ----------------------------------------------------------------------------------------------------------------------------------------------------------------*/

    return (
        <div className="mx-n3">
            {/* <Ibox className="mt-3" title="Service Map"> */}
                { showMap &&
                    <Map {...viewport}
                        ref={mapRef}
                        onMove={evt => setViewport(evt.viewState)}
                        mapboxAccessToken="pk.eyJ1IjoiYmxha2Vjb2RleiIsImEiOiJja2twemEyZ3ozMXZtMnVudzh6ajRkdG5wIn0.ZJ6dJHj6rJbOrDiBUuY2MA"
                        style={{ height: `calc(100vh${(numPanels(1))?'':' - 90px'})` }}
                        mapStyle="mapbox://styles/mapbox/streets-v12"
                        cursor={cursor}
                        attributionControl={ false }
                    >
                        <GeolocateControl position="top-left" />
                        <NavigationControl position="top-right" />
                        {/* {!rendering && startMarker} */}
                        {/* {!rendering && gpsCoordinates} */}
                        {/* {!rendering && stillMarkers} */}
                        {/* {!rendering && markers} */}
                        {/* {!rendering && selectedMarker} */}
                        {!rendering && technicianMarkers}
                    </Map>
                }
            {/* </Ibox> */}
        </div>
    );
}
